export default __webpack_public_path__ + "static/media/figuremap5.edfe02d5.png";